import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { CadastrarReuniaoComponent } from './cadastrar-reuniao/cadastrar-reuniao.component';
import { ReuniaoComponent } from './reuniao.component';


const routes: Routes = [
  { path: 'reunioes/cadastrar', component: CadastrarReuniaoComponent, canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.REUNIOES_ACOES_GERENCIAIS}  },
  { path: 'reunioes', component: ReuniaoComponent, canActivate: [AuthGuard] ,resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.REUNIOES_ACOES_GERENCIAIS} },
  { path: 'menu-sap/reunioes/cadastrar', component: CadastrarReuniaoComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.REUNIOES_SAP } },
  { path: 'menu-sap/reunioes', component: ReuniaoComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.REUNIOES_SAP } },
  { path: 'menu-pedagogico/reunioes/cadastrar', component: CadastrarReuniaoComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.REUNIOES_PEDAGOGICO } },
  { path: 'menu-pedagogico/reunioes', component: ReuniaoComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.REUNIOES_PEDAGOGICO } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReuniaoRoutingModule { }
